import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { Label } from "./Label";
import { Value } from "./Value";

export interface CheckoutPreviewEntryProps {
  className?: string;
  dataTestId?: string;
  hide?: boolean;
  label: string | React.ReactNode;
  labelClassName?: string;
  labelSize?: "xs" | "sm" | "md";
  labelWeight?: "normal" | "medium" | "semibold";
  tooltip?: string;
  value?: string;
  valueColor?: "text-green-700" | "text-primary";
  valueSize?: "sm" | "md" | "lg";
  valueWeight?: "normal" | "medium" | "semibold";
}

export const PreviewEntry = ({
  className,
  label,
  labelSize = "sm",
  labelWeight = "normal",
  labelClassName = "",
  tooltip,
  value,
  valueSize = "sm",
  valueColor = "text-primary",
  valueWeight = "normal",
  hide = false,
  dataTestId,
}: CheckoutPreviewEntryProps) => {
  if (hide) {
    return null;
  }

  return (
    <div
      className={classNames(
        className,
        "flex flex-row items-center justify-between space-x-2 whitespace-nowrap md:space-x-3",
      )}
      data-testid={dataTestId}
    >
      <Label
        size={labelSize}
        weight={labelWeight}
        className={labelClassName}
        tooltip={tooltip}
      >
        {label}
      </Label>
      {value && (
        <Value size={valueSize} weight={valueWeight} color={valueColor}>
          {value}
        </Value>
      )}
    </div>
  );
};
